import EndScreenPopup from './EndScreenPopup';

export default EndScreenPopup;
